import { Typography } from '@material-ui/core'
import React from 'react'



export const DampHeatview = ({ procedureData }: { procedureData: any }) => {
  return (
    <div>
      <Typography variant="body1">
        Test duration :{procedureData?.damp_heat?.test_duration ? `${procedureData.damp_heat.test_duration }hours`: "N/A"} 
      </Typography>
      <Typography variant="body1">
        Test temperature : {procedureData?.damp_heat?.test_temperature ? `${procedureData.damp_heat.test_temperature} °C`: "N/A"} 
      </Typography>
      <Typography variant="body1">
        Test Humidity : {procedureData?.damp_heat?.test_humidity ?`${ procedureData.damp_heat.test_humidity}  %RH`: "N/A"}
      </Typography>
      {(procedureData?.tsd_version ==="v12" &&
      <Typography variant="body1">
        Weight : {procedureData?.damp_heat?.weight ?`${ procedureData.damp_heat.weight}  g`: "N/A"}
      </Typography>
      )}
      <Typography variant="body1">
        Calibration Date : {procedureData?.damp_heat?.equipment_calibration_date ? procedureData.damp_heat.equipment_calibration_date.substring(0, 10) : "N/A"}
      </Typography>

    </div>
  )
}


